// import {useStorage} from '@vueuse/core';
import {defineStore} from 'pinia';
import {computed, ref} from 'vue';
import {buildImagePath, preloadImages, timeout} from './preload';
import {BlindPosition, FabricTone, FrameColour, IndoorOutdoor, TimeOfDay} from './types';

type View = 'loading' | 'visualiser' | 'error';
// const SIXTY_DAYS = 5_184_000_000;

export const useStore = defineStore('global', () => {
    const view = ref<View>('loading');
    const showOnboarding = ref(false);
    // const lastOnboarding = useStorage<number | null>('last-visualiser-onboarding', null, localStorage);

    const blindPosition = ref<BlindPosition>(BlindPosition.Closed);
    const frameColour = ref<FrameColour>(VisualiserConfig.locale === 'au' ? FrameColour.Monument : FrameColour.Bronze);
    const fabricTone = ref<FabricTone>(FabricTone.Dark);
    const indoorOutdoor = ref<IndoorOutdoor>(IndoorOutdoor.Outdoor);
    const timeOfDay = ref<TimeOfDay>(TimeOfDay.Day);

    const currentImage = computed(() => buildImagePath(blindPosition.value, frameColour.value, fabricTone.value, indoorOutdoor.value, timeOfDay.value));

    async function preloadData() {
        // const now = new Date().getTime();
        // if (lastOnboarding.value == null || +lastOnboarding.value < (now - SIXTY_DAYS)) {
        //     showOnboarding.value = true;
        //     lastOnboarding.value = now;
        // }

        const preload = async () => {
            await preloadImages();
        };
        const minLoad = async () => {
            await timeout(0);//4_000);
        };
        const maxLoad = async () => {
            await timeout(30_000);
            throw new Error('Unable to communicate with visualiser service. (Timeout)');
        };

        try {
            const loading = Promise.all([preload(), minLoad()]);
            await Promise.race([loading, maxLoad()]);
            view.value = 'visualiser';
        } catch (reason) {
            console.error(reason);
            view.value = 'error';
        }
    }

    return {
        view,
        showOnboarding,
        blindPosition,
        frameColour,
        fabricTone,
        indoorOutdoor,
        timeOfDay,
        currentImage,
        preloadData,
    };
});
